import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../services/filtering/filter-form-render-service/';
import messages from '../messages';

export const serialNumberRequired = {
  id: 'serialNumberRequired',
  displayName: <FormattedMessage {...messages.serialNumberRequiredColumnHeader} />,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'IsSerialNumberRequired',
  render: (criteriaInformations: unknown) => renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations),
};
